import { h } from 'preact';
import * as BaseComp from 'components/bolt/movieDetails/movieDetails.js';
import { joinClasses } from 'utils/utils';

import s from 'components/bolt/movieDetails/movieDetails.sss';

export default class MovieDetails extends BaseComp.default {

	renderTT(tt = {}) {
		return (
			<svg class={joinClasses(s.starfield, this.props.visible && s.visible)} viewBox="0 0 436 297" width="436" height="297" role="img" aria-labelledby="starfield-main-logo-title starfield-main-logo-desc">
				<title id="starfield-main-logo-title">Starfield Logo</title>
				<desc id="starfield-main-logo-desc">Logo for the game Starfield</desc>
				<mask id="starfield-arc-mask">
					<rect x="0" y="0" width="436" height="297" fill="white" />
					<path id="starfield-arc-mask-T" d="M54 125.2h22v5.8H54z" fill="black" />
					<path id="starfield-arc-mask-L" d="M340 171.1h22v5.8h-22z" fill="black" />
				</mask>
				{/* Letters appart from T and L */}
				<g transform="translate(0 125.59)">
					<path d="M105.6 30.5l6.2-16.3 6.2 16.3 1.1 2.9 4.6 12.1h6.5l-16-40.1h-4.6L93.2 45.5h6.6l4.6-12.1z" />
					<path d="M236.7 10.9V5.4h-27.1v40.1h5.9V26.8h19v-5.5h-19V10.9z" />
					<path d="M261.1 5.4h6v40.1h-6z" />
					<path d="M323 11.1V5.4h-27v40.1h28.4v-5.7H302v-12h19v-5.7h-19v-11z" />
					<path d="M430.3 6.2h.9v2.7h.4V6.2h.9v-.4h-2.2z" />
					<path d="M435.3 5.8l-1 1.9-.9-1.9h-.4v3.1h.4V6.7l.7 1.4h.4l.8-1.4v2.2h.4V5.8z" />
					<path d="M422.1 6.6c-2.8-1.1-6.2-1.1-10.1-1.2h-11.8v40.2h11c6.3 0 10.1 0 13.9-3 4.6-3.6 7.2-9.8 7.2-17.2 0-9-4-16.4-10.2-18.8zm-2 32.3c-2.2 1-6.2 1-8.6 1h-5.3V11.1h5.4c4.5 0 6.4 0 8.3.8 3.9 1.7 6.4 7.2 6.4 13.6 0 7.3-3.1 12-6.2 13.4z" />
					<path d="M15.9 9.8c3.1 0 5.7 1.2 7.2 3.3.5.6.8 1.3 1.1 2l.3.8H31l-.4-1.5c-1.3-4.6-5.9-10-14.6-10-6.6 0-13.7 2.9-13.7 11 0 8.4 7.7 10.3 12.3 11.5l.4.1c4.5 1.2 6.5 1.7 8 3 1.2 1 1.9 2.5 1.8 4.1 0 3.1-2.4 6.8-9.3 6.8-1.9 0-6.6-.4-8.5-4.2-.4-.8-.6-1.7-.7-2.6l.1-1.1H0l.2 1.4c.7 4 2.8 7.5 5.9 9.6 2.5 1.6 5.8 2.5 9.5 2.5 10 0 15.3-6.3 15.3-12.5 0-3.7-1.7-8.7-9.5-11.1-.7-.3-2.8-.8-5.4-1.5-1.1-.3-2-.5-2.3-.6-2.9-.9-5.5-2.1-5.5-5.4.1-5.4 6.5-5.6 7.7-5.6z" />
					<path d="M182.7 17.4c0-3.1-.8-9.2-7.5-11.3-2.5-.8-7.9-.6-10.6-.6h-12.1v40.1h6V28.8h7.1l11.9 16.7h7.5l-12.4-17c2.1-.3 4.8-1 7-3.1 2-2 3.1-4.8 3.1-8zm-10.4 5.5c-2 .3-4.1.4-6.1.3h-7.7V10.9h8c4.5 0 4.8.1 5.7.2 3.9.8 4.5 4.1 4.5 6 0 1.9-.5 5-4.4 5.8z" />
				</g>
				{/* top of T */}
				<path d="M80 131v5.5H50.2V131z" />
				{/* bottom of L */}
				<path d="M377.7 165.4v5.8h-29.6c.2-1.3.5-3.2.8-5.8h28.8z" />
				<path class={joinClasses(s.arc, s.t)} fill="none" mask="url(#starfield-arc-mask)" stroke="currentColor" stroke-width="7.1" d="M65.6 131.2c-.7 5.8-1.1 11.7-1.1 17.7 0 6.1.4 12.2 1.1 18.1 8.9 71.3 69.7 126.4 143.4 126.4 71.2 0 130.4-51.5 142.3-119.3" />
				<path class={joinClasses(s.arc, s.l)} fill="none" mask="url(#starfield-arc-mask)" stroke="currentColor" stroke-width="7.1" d="M351.9 170.7c1.1-7.1 1.6-14.4 1.6-21.8C353.5 69.1 288.8 4.4 209 4.4c-72.9 0-133.2 54-143.1 124.1" />
			</svg>
		);
	}

}
